<template>
    <div>
        <router-link class="button is-primary is-pulled-right" :to="{ name: 'admin-create' }">
            New Admin
        </router-link>
        <table class="table">
            <thead>
            <tr>
                <th>User</th>
                <th>Login</th>
                <th>Role</th>
                <th>Last Updated</th>
                <th>Created</th>
                <th>Actions</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="user in admins">
                <td>
                    <router-link :to="{ name: 'admin', params: {id: user.id}}">
                        {{ user.first_name }} {{ user.last_name }}
                    </router-link>
                </td>
                <td>{{ user.username }}</td>
                <td>{{ user.role }}</td>
                <td>{{ user.created_at | moment("from", "now") }}</td>
                <td>{{ user.updated_at | moment("from", "now") }}</td>
                <td>
                    <a class="delete" v-if="user.id !== admin.id" @click="deleteAdmin(user)"></a>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    import {mapGetters} from "vuex"
    import {DELETE_ADMIN} from "../../store/mutation-types"
    export default {
        data() {
            return {}
        },
        computed: mapGetters(['admins', 'admin']),
        methods: {
            deleteAdmin(admin) {
                this.$store.dispatch(DELETE_ADMIN, admin);
            }
        }
    };
</script>



// WEBPACK FOOTER //
// AdminList.vue?c75a29b8